module.exports = __webpack_public_path__ + "static/media/PlanIndiaLogo.055c873f.png";